<app-data-set
	#dataSet
	[dataSource]="dataSource"
	[rowId]="rowId"
	defaultPresentationMode="table"
	firstColumnProperty="device.serialNumber"
>
	<app-data-set-toolbar>
		<div *appSearchActionGroup style="flex: 1">
			<app-data-set-search
				defaultFilterName="serialNumber"
				[defaultFilterLabel]="filterLabels.serialNumber"
				[placeholder]="filterLabels.defaultPlaceholder"
			>
				<div class="filter-grid" [style.--columns]="4">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.serialNumber }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('serialNumber')"
								(ngModelChange)="dataSet.filter('serialNumber', filterLabels.serialNumber, $event)"
								data-automation-id="serial-number-input"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.propertyName }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('propertyName')"
								(ngModelChange)="dataSet.filter('propertyName', filterLabels.propertyName, $event)"
								data-automation-id="property-name-input"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.groups }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('group')"
								(ngModelChange)="dataSet.filter('group', filterLabels.groups, $event)"
								data-automation-id="device-groups-input"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<!-- FIXME: FILTER FIXES -  Display Status should be drop-down -->
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.status }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('displayStatus')"
								(ngModelChange)="dataSet.filter('displayStatus', filterLabels.status, $event)"
								data-automation-id="status-input"
							/>
						</mat-form-field>
					</div>
				</div>

				<div class="filter-grid" [style.--columns]="4">
					<div class="filter-item">
						<!-- FIXME: FILTER FIXES -  Should use Country Code dropdown -->
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.country }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('country')"
								(ngModelChange)="dataSet.filter('country', filterLabels.country, $event)"
								data-automation-id="country-input"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.townCity }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('townCity')"
								(ngModelChange)="dataSet.filter('townCity', filterLabels.townCity, $event)"
								data-automation-id="city-input"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.stateProvinceCounty }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('stateProvince')"
								(ngModelChange)="dataSet.filter('stateProvince', filterLabels.stateProvinceCounty, $event)"
								data-automation-id="province-input"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.postalCode }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('zipPostalCode')"
								(ngModelChange)="dataSet.filter('zipPostalCode', filterLabels.postalCode, $event)"
								data-automation-id="postal-code-input"
							/>
						</mat-form-field>
					</div>
				</div>
			</app-data-set-search>
		</div>

		@if (hasTransferDeviceInventoryOwnershipCapability) {
			<div *appSelectedActionGroup>
				<app-data-set-action-button
					icon="swap_vert"
					label="Transfer Ownership"
					i18n-label="@@company-devicesTransferOwnership"
					data-automation-id="transfer-ownership-one-button"
					(click)="transferOwnershipClicked()"
				>
				</app-data-set-action-button>
			</div>
		}
	</app-data-set-toolbar>

	<app-data-set-content>
		<app-data-set-table-view>
			@if (loadingService.isLoading(getDevicesByCompanyIdLoadingKey) || !finishedLoadingInitData) {
				<app-data-set-loading-row />
			}

			<table
				mat-table
				[dataSource]="dataSource"
				matSort
				[hidden]="loadingService.isLoading(getDevicesByCompanyIdLoadingKey) || !finishedLoadingInitData"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
						No records found.
					</td>
				</tr>

				<ng-container matColumnDef="rowSelection">
					<th mat-header-cell *matHeaderCellDef>
						@if (hasTransferDeviceInventoryOwnershipCapability) {
							<mat-checkbox
								[checked]="isSelectedAllChecked()"
								[indeterminate]="isSelectAllIntermediate()"
								(change)="onSelectAllToggle($event.checked)"
							></mat-checkbox>
						}
					</th>
					<td mat-cell *matCellDef="let row">
						@if (hasTransferDeviceInventoryOwnershipCapability) {
							<app-data-set-table-row-selection
								[data]="row"
								[appHasSystemCapability]
								has="transferDeviceInventoryOwnership"
							></app-data-set-table-row-selection>
						}
					</td>
				</ng-container>

				<ng-container matColumnDef="serialNumber">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyDevices-devicesSerialNumber2">
						Serial Number
					</th>
					<td mat-cell *matCellDef="let row">{{ row.device.serialNumber }}</td>
				</ng-container>

				<ng-container matColumnDef="deviceLocation">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyDevices-devicesDeviceLocation">
						Device Location
					</th>
					<td mat-cell *matCellDef="let row">
						{{ row.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.name }}
					</td>
				</ng-container>

				<ng-container matColumnDef="group">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyDevices-devicesGroup(s)">
						Device Group(s)
					</th>
					<td mat-cell *matCellDef="let row">
						<app-overflow-chip-list [chips]="row.groupNames">{{ row.groupNames }}</app-overflow-chip-list>
					</td>
				</ng-container>

				<ng-container matColumnDef="propertyName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyDevices-devicesPropertyName2">
						Property Name
					</th>
					<td mat-cell *matCellDef="let row">
						{{ row.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.name }}
					</td>
				</ng-container>

				<ng-container matColumnDef="address">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyDevices-devicesAddress">Address</th>
					<td mat-cell *matCellDef="let row">
						@if (row.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address) {
							<div
								[innerHtml]="
									row.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
										| address
								"
							></div>
						}
					</td>
				</ng-container>

				<ng-container matColumnDef="displayStatus">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyDevices-devicesStatus">Status</th>
					<td mat-cell *matCellDef="let row" class="status-cell">
						<app-device-status
							[device]="row.device"
							[installation]="row.device.activeDeviceAssignment?.activeInstallation"
						></app-device-status>
					</td>
				</ng-container>

				<ng-container matColumnDef="rowMenu">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row">
						@if (hasTransferDeviceInventoryOwnershipCapability) {
							<app-data-set-table-menu [menu]="menu" [row]="row"></app-data-set-table-menu>
						}
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
			</table>

			<mat-menu #menu="matMenu">
				<ng-template matMenuContent let-row="row">
					<button
						mat-menu-item
						(click)="onRowMenuTransferDeviceOwnershipClicked(row)"
						i18n="@@companyDevices-transferOwnership"
						data-automation-id="transfer-ownership-two-button"
					>
						Transfer Ownership
					</button>
				</ng-template>
			</mat-menu>
		</app-data-set-table-view>
	</app-data-set-content>
</app-data-set>
